/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e=2e4;function t(t){let n=0;let o=t.next(n);for(;!o.done&&n<e;)n+=50,o=t.next(n);return n>=e?1/0:n}export{t as calcGeneratorDuration,e as maxGeneratorDuration};
//# sourceMappingURL=calc-duration.js.map
